var map = {
	"./01-Ding.mp3": 614,
	"./02-Piep.mp3": 615,
	"./03-Glocke.mp3": 616,
	"./04-Magie.mp3": 617,
	"./05-Marimba.mp3": 618,
	"./06-Happy.mp3": 619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;